import { type ExcursionPropsServer } from "@op/puck-types";
import { ComponentRenderer } from "./ComponentRenderer";
import ExcursionRoot from "../components/puck/Root/ExcursionRoot";

export const ExcursionRenderer = ({ data }: ExcursionPropsServer) => {
  return (
    <div className="overflow-auto">
      <ExcursionRoot
        overline={data.root?.props?.overline ?? ""}
        title={data.root?.props?.title ?? ""}
      >
        {data.content.map((node) => (
          <ComponentRenderer key={node.props.id} node={node} />
        ))}
      </ExcursionRoot>
    </div>
  );
};
